module.exports = "./images/yavuskus-logo-yk-bordered.svg";